import React from 'react';
import {
  Button, Grid,
} from '@mui/material';
import { useTranslation } from '@gamiphy/react-i18n';
import { UnavowedPopup } from '@gamiphy/loyalty-station-desktop/components/popups/unavowed';
import { ReferralsStore } from '@gamiphy/loyalty-station-desktop/store/refferals';
import { observer } from 'mobx-react';
import { UserStore } from '@gamiphy/loyalty-station-desktop/store/user';
import InviteSteps from './InviteSteps';

export type Props = {
  onInvite: () => void;
};

const InviteFriend: React.FC<Props> = observer(({ onInvite }) => {
  const [popupOpen, setPopupOpen] = React.useState(false);
  const { t } = useTranslation();

  const onInviteClick = () => {
    if (UserStore.isRealUser) {
      onInvite();
    } else {
      setPopupOpen(true);
    }
  };

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="stretch"
      sx={{ textAlign: 'left' }}
      spacing={2}
    >
      <Grid size={12} sx={{ fontSize: '1.3rem', fontWeight: 400 }}>
        {t('referral.tab.title', 'Invite your friends and everybody wins')}
      </Grid>
      <Grid size={12} sx={{ fontSize: '1.3rem', fontWeight: 400 }}>
        {t('referral.tab.stepsTitle', 'How it works:')}
      </Grid>
      {ReferralsStore.appReferral && (
        <InviteSteps
          referrerPoints={ReferralsStore.appReferral.referrerPoints}
          refereePoints={ReferralsStore.appReferral.refereePoints}
        />
      )}
      <Grid container direction="column" alignItems="stretch" size={12}>
        <Button
          variant="contained"
          color="primary"
          onClick={onInviteClick}
          sx={{ width: '100%', display: 'block' }}
        >
          {t('missions.referral.cta', 'Invite')}
        </Button>
        <UnavowedPopup
          open={popupOpen}
          onClose={() => setPopupOpen(false)}
          title={t('unavowedPopup.rewardTitle', 'Sign up now to redeem your coupon for exclusive discounts!')}
        />
      </Grid>
    </Grid>
  );
});

export default InviteFriend;
